var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectResourceInfo } from "../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { selectIsQualifiedForMarket } from "../../selectors/selectContractInfo";
import { selectQuickSellProductsInfo } from "../../selectors/selectQuickSellInfo";
import { selectSoldResourceMaxAmount, selectSoldResourceMinAmount, } from "../../selectors/selectResourceInfo";
import { selectStorageInfo } from "../../selectors/selectStorageInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { utilNumber } from "../../utils/utilNumber";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { ButtonSellResource } from "../generic/common/ButtonSellResource";
import { componentWithProps } from "../generic/componentWithProps";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { ResourceBar } from "../generic/resource-bar/ResourceBar";
import { TextLoca } from "../generic/text/TextLoca";
import { TextLocaValueProportional } from "../generic/text/TextLocaValueProportional";
import { actionModalClose, actionModalSwapLast } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TradeComponent } from "../trade-component/TradeComponent";
import { actionQuickSellResourceSell } from "./actionQuickSell";
import { QuickSellResourceConfig } from "./QuickSellResourceConfig";
var DialogQuickSellDOM = /** @class */ (function (_super) {
    __extends(DialogQuickSellDOM, _super);
    function DialogQuickSellDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.getStorageAmount = function () {
            var _a = _this.props, wastedResourceInfo = _a.wastedResourceInfo, wastedResourceMaxAmount = _a.wastedResourceMaxAmount, storageCapacity = _a.storageCapacity;
            if (wastedResourceMaxAmount == undefined) {
                return;
            }
            return (React.createElement("div", { className: "flex flex--guts flex--stacked " + IdStyles.QuickSellContainerStorage + "  " + IdStyles.TextBoldPrimary },
                React.createElement(TextLoca, { id: IdLoca.inStorage }),
                React.createElement("div", { className: "flex flex-row flex--guts" },
                    React.createElement(ResourceIcon, { resource: wastedResourceInfo, styleId: IdStyles.IconLarge }),
                    React.createElement(TextLocaValueProportional, { available: wastedResourceMaxAmount, required: storageCapacity }))));
        };
        _this.getGoToComponent = function () {
            var _a = _this.props, wastedResourceInfo = _a.wastedResourceInfo, marketEnabled = _a.marketEnabled, onGoToClick = _a.onGoToClick;
            if (wastedResourceInfo == undefined) {
                return;
            }
            var resourceUsageInfo = _this.getResourceUsageInfo(wastedResourceInfo.type);
            var locaReplacements = new Map([
                [ReplacementLoca.zero_0, utilLoca.get(wastedResourceInfo.locaKey)],
            ]);
            return (React.createElement("div", { className: "flex flex--stacked flex--guts flex--around " + IdStyles.QuickSellContainerTip + " " + IdStyles.TextBoldPrimary },
                React.createElement("div", { className: "quick-sell-text_center w100" },
                    React.createElement(TextLoca, { id: resourceUsageInfo.quickSellLoca, replacements: locaReplacements })),
                React.createElement(ButtonPrimary, { onClick: function () {
                        onGoToClick(resourceUsageInfo.modalId);
                    }, disabled: !marketEnabled },
                    React.createElement("div", { className: "flex flex--around flex--aligned w100" },
                        React.createElement(Icon, { icon: IdIcon.RedArrowIcn, styleId: IdStyles.IconLarge }),
                        React.createElement(Icon, { icon: resourceUsageInfo.icon, styleId: IdStyles.IconLarge })))));
        };
        _this.getResourceUsageInfo = function (resourceType) {
            return QuickSellResourceConfig.get(resourceType);
        };
        _this.getTradeComponent = function () {
            var _a = _this.props, wastedResourceInfo = _a.wastedResourceInfo, purchasedResourceInfo = _a.purchasedResourceInfo, wastedResourceMinAmount = _a.wastedResourceMinAmount, wastedResourceMaxAmount = _a.wastedResourceMaxAmount;
            var sliderValue = _this.state.sliderValue;
            var wastedResourceAmount = sliderValue.multiply(wastedResourceInfo.sellValue.amount);
            return (React.createElement("div", { className: "flex flex--aligned flex--stacked flex--around flex__full" },
                React.createElement(TradeComponent, { wastedResourceInfo: wastedResourceInfo, wastedResourceAmount: sliderValue, purchasedResourceInfo: purchasedResourceInfo, purchasedResourceAmount: wastedResourceAmount, sliderValue: sliderValue, wastedResourceMinAmount: wastedResourceMinAmount, wastedResourceMaxAmount: wastedResourceMaxAmount, onSliderChange: _this.onSliderChange, backgroundStyle: IdStyles.QuickSellStatContainer }),
                React.createElement(ButtonSellResource, { onClick: _this.onTradeButtonClick },
                    React.createElement("div", null,
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.sell })))));
        };
        _this.getQuickSellTradeDescription = function () {
            var _a = _this.props, wastedResourceMinAmount = _a.wastedResourceMinAmount, wastedResourceInfo = _a.wastedResourceInfo;
            var locaReplacements = new Map([
                [ReplacementLoca.zero_0, utilNumber.format(wastedResourceMinAmount)],
                [
                    ReplacementLoca.one_1,
                    wastedResourceInfo ? utilLoca.get(wastedResourceInfo.locaKey) : "",
                ],
            ]);
            return (React.createElement("div", { className: "quick-sell-trade-description " + IdStyles.TextBoldPrimary },
                React.createElement(TextLoca, { id: IdLoca.storageFull2_desc, replacements: locaReplacements })));
        };
        _this.onSliderChange = function (value) {
            _this.setState({
                sliderValue: value,
            });
        };
        _this.onTradeButtonClick = function () {
            var _a = _this.props, wastedResourceInfo = _a.wastedResourceInfo, onSellItem = _a.onSellItem;
            var sliderValue = _this.state.sliderValue;
            onSellItem(wastedResourceInfo.id, sliderValue.toNumber());
        };
        _this.state = {
            sliderValue: props.wastedResourceMinAmount,
        };
        return _this;
    }
    DialogQuickSellDOM.prototype.render = function () {
        var storageAmount = this.getStorageAmount();
        var goToMarket = this.getGoToComponent();
        var quickSellTradeDescription = this.getQuickSellTradeDescription();
        var tradeComponent = this.getTradeComponent();
        var footerResources = [IdResource.Money, IdResource.Gold];
        var footerComponent = componentWithProps({
            ComponentType: ResourceBar,
            resources: footerResources,
        });
        return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.storageFull_title, onClose: this.props.onClose, className: IdStyles.ModalBackgroundQuickSell, footerRenderer: footerComponent },
            React.createElement("div", { className: "flex flex--aligned flex--around h100" },
                React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around h100" },
                    storageAmount,
                    goToMarket),
                React.createElement("div", { className: "flex flex--stacked " + IdStyles.QuickSellContainerSell },
                    quickSellTradeDescription,
                    tradeComponent))));
    };
    return DialogQuickSellDOM;
}(React.Component));
var mapState = function (state) {
    var nonCollectibleProduct = selectQuickSellProductsInfo(state);
    var wastedResourceInfo = selectResourceInfo(nonCollectibleProduct.resourceId);
    var purchasedResourceInfo = selectResourceInfo(wastedResourceInfo.sellValue.resourceId);
    return {
        marketEnabled: selectIsQualifiedForMarket(state),
        purchasedResourceInfo: purchasedResourceInfo,
        storageCapacity: selectStorageInfo(state),
        wastedResourceInfo: wastedResourceInfo,
        wastedResourceMaxAmount: selectSoldResourceMaxAmount(state, nonCollectibleProduct.resourceId),
        wastedResourceMinAmount: selectSoldResourceMinAmount(state, nonCollectibleProduct.resourceId),
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.QuickSell)); },
    onGoToClick: function (modalId) { return dispatch(actionModalSwapLast(modalId)); },
    onSellItem: function (itemId, amount) {
        return dispatch(actionQuickSellResourceSell(itemId, amount));
    },
}); };
export var DialogQuickSell = connect(mapState, mapDispatch)(DialogQuickSellDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-sell-dialog/DialogQuickSell.tsx
// module id = 2890
// module chunks = 3